import { render, staticRenderFns } from "./team_guide.vue?vue&type=template&id=2aae9437&scoped=true&"
import script from "./team_guide.vue?vue&type=script&lang=ts&"
export * from "./team_guide.vue?vue&type=script&lang=ts&"
import style0 from "./team_guide.vue?vue&type=style&index=0&id=2aae9437&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae9437",
  null
  
)

export default component.exports